import React from "react";
import BlurText from "../../Reactbits/TextAnimations/BlurText/BlurText";

function Hero() {
  return (
    <div
      style={{
        backgroundImage: "url('/media/images/Academics.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        minHeight: "93vh",
        display: "flex",
        alignItems: "center",
        color: "white",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col text-center text-md-start">
            <h1
              className="fw-bold"
              style={{ fontSize: "10vw", maxWidth: "100%", lineHeight: "1.2" }}
            >
              <BlurText
                text="Academics"
                className="display"
                animateBy="chars"
                direction="top"
                delay={70}
              />
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
